import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
type GuaranteeProps = {
  tone?: 'default' | 'onDark';
  className?: string;
};

/** Subtle reassurance block shown directly under a checkout CTA. */
export function Guarantee({
  tone = 'default',
  className = ''
}: GuaranteeProps) {
  const isDark = tone === 'onDark';
  return <div className={`flex flex-col items-center gap-1 text-center ${className}`} data-id="element-54" data-mp="1x5mw8ywxg12y">
      <p className={`flex items-center gap-1.5 text-sm font-semibold ${isDark ? 'text-white' : 'text-ink-700'}`} data-id="element-55" data-mp="19dzeb6hn80ct">
        <ShieldCheckIcon className={`h-4 w-4 ${isDark ? 'text-white' : 'text-safe'}`} aria-hidden="true" data-id="element-56" data-mp="14dl4pk0e8ico" />
        7-day money-back guarantee
      </p>
      <p className={`font-mono text-[0.65rem] font-semibold uppercase tracking-[0.12em] ${isDark ? 'text-orangey-100' : 'text-ink-400'}`} data-id="element-57" data-mp="1ecsqmvl71lbe">
        One-time payment · No subscription
      </p>
    </div>;
}